import { Grid, Switch } from "@mui/material";
import { useState } from "react";
import { CadastrarVincularCliente } from "../../../../../clientes/containers/CadastrarVincularCliente";
import { SalvarEndereco } from "../../../../../clientes/containers/SalvarEndereco";
import { OperacaoCategoriasProdutosContainer } from "../../../../../produtos/containers/OperacaoCategoriasProdutosContainer";
import { CheckoutPaper } from "../../../../components/CheckoutPaper";
import { ClientePaper } from "../../../../components/ClientePaper";
import { EnderecoPaper } from "../../../../components/EnderecoPaper";
import { MetodoPagamentoSelect } from "../../../../components/MetodoPagamentoSelect";
import { useOperacaoContext } from "../../../../contexts/OperacaoContext";
import { TipoPedido } from "../../../../enum/TipoPedido";
import { CategoriasContainer, Layer, ProdutosPaper } from "./styles";
import { PedidosNaoConcluidosContainer } from "../PedidosNaoConcluidosContainer";
import { useTamanhoTela } from "../../../../../core/hooks/useTamanhoTela";
import { CarrinhoMobilePaper } from "../../styles";
import { ProdutosCarrinhoContainer } from "../../../../../produtos/containers/ProdutosCarrinhoContainer";
import { useFetchCategorias } from "../../../../../produtos/hooks/useFetchCategorias";
import { EmitirNotaFiscalModal, TipoPessoa } from "../EmitirNotaFiscalModal";
import { useConfiguracoesPedidoContext } from "../../../../contexts/ConfiguracoesPedidoContext";
import { GestaoEnderecosCliente } from "../../../../../clientes/containers/GestaoEnderecosCliente";
import { IEndereco } from "../../../../../core/interfaces/IEndereco";
import { DividirPagamento } from "../DividirPagamento";
import { IPagamentoPedido } from "../../../../interface/IPagamentoPedido";
import { AlterarPrecoFreteModal } from "../../../../components/AlterarPrecoFreteModal";
import { BotoesAcoesCheckout } from "../../../../components/BotoesAcoesCheckout";
import { FidelidadeCardsWrapper } from "../../../../components/FidelidadeCardsWrapper";

export const OperacaoDelivery = () => {
    const { modeloTela } = useTamanhoTela();
    const { categorias } = useFetchCategorias();

    const {
        cliente,
        vincularCliente,
        endereco,
        vincularEndereco,
        adicionarProduto,
        alterarEndereco,
        removerCliente,
        valorTotalPedido,
        valorFrete,
        pagamentos,
        produtos,
        aumentarQuantidade,
        diminuirQuantidade,
        removerProduto,
        fecharPedido,
        loading,
        alterarTipo,
        agendarHorario,
        agendadoPara,
        alterarPagamentos,
        salvarPedido,
        numeroPedidoDiario,
        editarProduto,
        numeroTotalItens,
        switchNotaFiscal,
        handleSwitchNotaFiscal,
        configuracaoNFCe,
        loadingVincularEndereco,
        fluxoContexto,
        switchImprimirAutomatico,
        handleSwitchImprimirAutomatico,
        abrirDrawerPagamento,
        alterarValorFrete,
        cupons,
        abrirDrawerCupons,
        aplicarCupom
    } = useOperacaoContext();

    const [modalAlterarPrecoAberta, setModalAlterarPrecoAberta] = useState(false);
    const [mostrarHorario, setMostrarHorario] = useState(false);

    const handleAlterarPagamento = (pagamento?: IPagamentoPedido) => {
        if (!pagamento?.metodoPagamento) {
            alterarPagamentos(undefined);
        } else {
            alterarPagamentos([pagamento]);
        }
    }


    return (
        <Grid
            container
            spacing={0}
            sx={{ width: "100%", height: "100%" }}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <Grid item xs={12} md={9} lg={9}>
                <ProdutosPaper variant="outlined">
                    <CategoriasContainer>
                        <OperacaoCategoriasProdutosContainer
                            categorias={categorias}
                            adicionarProduto={adicionarProduto}
                            contexto={TipoPedido["delivery"]}
                            cliente={cliente}
                            endereco={endereco}
                            fecharPedido={fecharPedido}
                            carrinhoContainer={
                                <ProdutosCarrinhoContainer
                                    categorias={categorias}
                                    aumentarQuantidade={aumentarQuantidade}
                                    diminuirQuantidade={diminuirQuantidade}
                                    editarProduto={editarProduto}
                                    produtosCarrinho={produtos}
                                    removerProduto={removerProduto}
                                />
                            }
                        />
                        {!cliente && (
                            <Layer>
                                <CadastrarVincularCliente vincularCliente={vincularCliente} />
                            </Layer>
                        )}
                        {cliente && !endereco && (
                            <Layer>
                                <GestaoEnderecosCliente
                                    cliente={cliente}
                                    salvar={vincularEndereco}
                                    cancelar={removerCliente}
                                    opcoes={["VINCULAR_ENDERECO", "EDITAR_ENDERECO", "EXCLUIR_ENDERECO"]}
                                    loading={loadingVincularEndereco}
                                />
                            </Layer>
                        )}
                    </CategoriasContainer>
                </ProdutosPaper>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
                <CheckoutPaper
                    loading={loading}
                    valorFrete={valorFrete}
                    valorTotalPedido={valorTotalPedido}
                    numeroTotalItens={numeroTotalItens}
                    numeroPedidoDiario={numeroPedidoDiario}
                    opcoes={[
                        {
                            titulo: "Concluir",
                            funcao: fecharPedido,
                            atalho: "F8"
                        },
                        {
                            titulo: "Salvar",
                            funcao: salvarPedido,
                            atalho: "F9"
                        },
                        {
                            titulo: "Dividir pagamento",
                            funcao: abrirDrawerPagamento
                        }
                    ]}
                >
                    <ClientePaper
                        cliente={cliente}
                        removerCliente={removerCliente}
                        enderecoPaper={
                            <EnderecoPaper
                                endereco={endereco}
                                alterarEndereco={alterarEndereco}
                                alterarPrecoFrete={() => setModalAlterarPrecoAberta(true)}
                            />
                        }
                    />
                    <FidelidadeCardsWrapper
                        cliente={cliente}
                        cupons={cupons}
                        aplicarCupom={aplicarCupom}
                        adicionarProduto={adicionarProduto}
                        categorias={categorias || []}
                        produtos={produtos}
                    />
                    <MetodoPagamentoSelect
                        pagamento={pagamentos[0]}
                        onChange={handleAlterarPagamento}
                        valorTotal={valorTotalPedido}
                    />
                    <BotoesAcoesCheckout
                        switchImprimirAutomatico={switchImprimirAutomatico}
                        handleSwitchImprimirAutomatico={handleSwitchImprimirAutomatico}
                        switchNotaFiscal={switchNotaFiscal}
                        handleSwitchNotaFiscal={handleSwitchNotaFiscal}
                        configuracaoNFCeObrigatorio={configuracaoNFCe?.obrigatorio}
                        agendadoPara={agendadoPara}
                        agendarHorario={agendarHorario}
                        mostrarHorario={mostrarHorario}
                        toggleHorario={() => setMostrarHorario(!mostrarHorario)}
                        quantidadeCupons={cupons.length}
                        abrirDrawerCupons={abrirDrawerCupons}
                    />
                    {modeloTela == "mobile" && (produtos?.length > 0) && (
                        <CarrinhoMobilePaper variant="outlined" sx={{ marginTop: "1rem" }}>
                            <ProdutosCarrinhoContainer
                                categorias={categorias}
                                produtosCarrinho={produtos}
                                aumentarQuantidade={aumentarQuantidade}
                                diminuirQuantidade={diminuirQuantidade}
                                removerProduto={removerProduto}
                                editarProduto={editarProduto}
                            />
                        </CarrinhoMobilePaper>
                    )}
                    <AlterarPrecoFreteModal
                        open={modalAlterarPrecoAberta}
                        valorAtual={valorFrete}
                        onClose={() => setModalAlterarPrecoAberta(false)}
                        onConfirm={(novoValor) => {
                            alterarValorFrete(novoValor);
                            setModalAlterarPrecoAberta(false);
                        }}
                        loading={loading}
                    />
                </CheckoutPaper>
            </Grid>
        </Grid>
    );
}